export default __webpack_public_path__ + "static/media/banner-details.939e8287.png";